import React, { useState, useEffect } from 'react'
import './App.css'
import './Downloadtickets.css'
import { Redirect, useLocation, useHistory } from 'react-router-dom'
import Axios from 'axios'
import {
  IoIosArrowBack,
  IoIosCheckmarkCircle,
  IoIosRadioButtonOff,
  IoIosWarning,
} from 'react-icons/io'
import ClipLoader from 'react-spinners/ClipLoader'
import TopBarProgress from 'react-topbar-progress-indicator'
import NumberFormat from 'react-number-format'
import { ImMan } from 'react-icons/im'
import { FaChild } from 'react-icons/fa'
import { BiMenu, BiPrinter, BiScan, BiShieldAlt2 } from 'react-icons/bi'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import { API_URL } from './config'

const categoryLabel = (c) => {
  const key = String(c || '')
    .trim()
    .toLowerCase()
  if (key === 'general') return 'General'
  if (key === 'vip') return 'VIP'
  if (key === 'vvip') return 'VVIP'
  return String(c || '').trim()
}

const Money = ({ value }) => (
  <NumberFormat
    value={Number(value || 0).toFixed(2)}
    prefix="R"
    displayType="text"
    thousandSeparator={true}
    decimalSeparator="."
    fixedDecimalScale={true}
  />
)

const Downloadtickets = () => {
  const location = useLocation()
  const history = useHistory()
  const { eventid } = location.state || {}

  const [error, setError] = useState('')
  const [errorDisplay, setErrorDisplay] = useState(false)
  const [ticketCategory, setTicketCategory] = useState([])
  const [, setTicketCount] = useState(0)
  const [progressbar, setProgressbar] = useState(false)
  const [preparing, setPreparing] = useState(false)
  const [budget, setBudget] = useState(0)
  const [balance, setBalance] = useState(0)
  const [ticketPrint, setTicketPrint] = useState(0)
  const [estimatedRevenue, setEstimatedRevenue] = useState(0)
  const [count, setCount] = useState(0)

  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState()
  const [collapsed, setCollapsed] = useState(isMobile)

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  useEffect(() => {
    if (!location.state || !location.state.eventid) {
      history.push('/dashboard')
      return
    }

    const businessid = localStorage.getItem('businessid')
    document.title = 'Prepare tickets - Karamale'
    const base = `${API_URL}/apps/kscanner/webservices.php`
    const opts = { withCredentials: true }

    Axios.get(`${base}?query=GETBUDGET&eventid=${eventid}`, opts).then((r) => {
      setBudget(r.data.budget)
      setBalance(r.data.balance)
    })

    Axios.get(`${base}?query=PREPAREDOWNLOADS&eventid=${eventid}`, opts).then((r) => {
      setTicketPrint(r.data.ticketPrint)
      setEstimatedRevenue(r.data.estimatedRevenue)
    })

    Axios.get(`${base}?query=TICKETSTATUS&eventid=${eventid}`, opts).then((r) => {
      setTicketCount(r.data.ticketCount)
    })

    Axios.get(
      `${base}?query=PREPARETICKETS&eventid=${eventid}&businessid=${businessid}`,
      opts,
    ).then((r) => {
      setTicketCategory(r.data.data === 0 ? [] : r.data)
    })

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)
    return () => window.removeEventListener('resize', updateIsMobile)
  }, [count])

  const navState = () => {
    const s = location.state
    return {
      eventid: s.eventid,
      eventname: s.eventname,
      poster: s.poster,
      eventdate: s.eventdate,
      enddate: s.enddate,
      event_date: s.event_date,
      finish_date: s.finish_date,
      theme: s.theme,
      venue: s.venue,
      expectednum: s.expectednum,
      time: s.time,
      endtime: s.endtime,
      prevpage: s.prevpage,
      currentpage: 'editevent',
    }
  }

  const increase = () => {
    history.push({ pathname: 'campaign', state: navState() })
  }

  const showError = (msg) => {
    setError(msg)
    setErrorDisplay(true)
  }

  const handleQty = (ticketid, category, instock, price, group) => (event) => {
    setTimeout(() => setErrorDisplay(false), 4000)

    const value = event.target.value
    if (parseInt(value) > parseInt(instock)) {
      const who = group === 'kids' ? 'kids' : 'adults'
      showError(
        parseInt(instock) === 0
          ? `${categoryLabel(category)} tickets for ${who} are out of stock`
          : `Only ${instock} tickets available for ${categoryLabel(category)}`,
      )
    } else {
      setErrorDisplay(false)
      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=PREPARETICKETSDOWNLOAD&ticketid=${ticketid}&instock=${instock}&eventid=${eventid}&ticketsNumber=${value}&price=${price}&group=${group}`,
        { withCredentials: true },
      ).then((response) => {
        setTicketPrint(response.data.ticketPrint)
        setEstimatedRevenue(parseInt(response.data.total_revenue))
        setCount((c) => c + 1)
      })
    }

    history.replace({ pathname: '/downloadtickets', state: navState() })
  }

  const selected = (ticketid, checked) => {
    setProgressbar(true)

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=MARKTICKETCATEGORY&ticketid=${ticketid}&eventid=${eventid}&checked=${checked}`,
      { withCredentials: true },
    ).then((response) => {
      setTicketCount(response.data.ticketCount)
      setTicketPrint(response.data.ticketPrint)
      setProgressbar(false)
      setCount((c) => c + 1)
    })

    history.replace({ pathname: '/downloadtickets', state: navState() })
  }

  const prepare = () => {
    if (preparing) return
    setPreparing(true)
    const ticketLimit = ticketPrint
    const costs = ticketPrint * 1

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=LOADTEMPORARYTICKETS&eventid=${eventid}&ticketLimit=${ticketLimit}&reprintNumber=${ticketPrint}`,
      { withCredentials: true },
    )
      .then(() => {
        localStorage.setItem('ticketLimit', ticketPrint)
        localStorage.setItem('ticketPrint', ticketPrint)
        localStorage.setItem('estimatedRevenue', estimatedRevenue)
        localStorage.setItem('costs', costs.toFixed(1))
        localStorage.setItem('budget', budget)
        localStorage.setItem('balance', balance)
        history.push({ pathname: '/ticketdownload' })
      })
      .catch(() => {
        setPreparing(false)
        showError('Could not prepare the download. Try again.')
        setTimeout(() => setErrorDisplay(false), 4000)
      })
  }

  const handleToggle = () => setCollapsed((prev) => !prev)

  if (localStorage.getItem('businessname') === null) {
    return <Redirect to="/login" />
  }
  if (localStorage.getItem('download') === null) {
    return <Redirect to="/dashboard" />
  }
  if (!location.state) {
    return <Redirect to="/dashboard" />
  }

  const costs = ticketPrint * 1
  const canPrepare = ticketPrint > 0 && costs < budget
  const lowBalance = parseInt(costs) > parseInt(budget) && costs > 0

  const renderRow = (item, group) => {
    const kids = group === 'kids'
    const price = kids ? item.kids_ticket_price : item.ticket_price
    const instock = kids ? item.kids_instock : item.instock
    const executed = kids ? item.kids_executed : item.executed
    const number = kids ? item.kids_ticket_number : item.ticket_number
    const revenue = kids ? item.kids_revenues : item.revenues

    return (
      <div className="dt-row">
        <div className="dt-row-info">
          <span className="dt-who">
            {kids ? <FaChild color="#2b8fd6" /> : <ImMan color="#e07b00" />}
            {kids ? 'Child' : 'Adult'}
            <span className="dt-price">R{price}</span>
          </span>
          <span className="dt-sub">
            Est. revenue R{executed == 1 ? 0 : number == 0 ? 0 : revenue}
            <span className="dt-dot" />
            {instock} in stock
          </span>
        </div>
        <input
          type="number"
          inputMode="numeric"
          min={0}
          max={instock}
          className="dt-input"
          placeholder={`Max ${instock}`}
          aria-label={`${kids ? 'Child' : 'Adult'} ${categoryLabel(item.category)} tickets`}
          onChange={handleQty(item.ticketid, item.category, instock, price, group)}
          defaultValue={executed == 1 ? '' : number < 1 ? '' : number}
        />
      </div>
    )
  }

  return (
    <div className="view">
      {progressbar && <TopBarProgress />}
      <Header />
      <SideNav collapsed={collapsed} onToggle={handleToggle} />
      <div
        className="main-content"
        style={{
          marginTop: 40,
          marginLeft: isMob ? '0px' : collapsed ? '60px' : '240px',
        }}
      >
        {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

        {isMob && collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}

        <div className="dt">
          <div className="dt-shell">
            <div className="dt-top">
              <button onClick={() => history.goBack()} className="dt-back">
                <IoIosArrowBack size={22} />
                Back
              </button>
            </div>

            <header className="dt-head">
              <h1>Prepare tickets</h1>
              <p>{localStorage.getItem('eventname')}</p>
              <div className="dt-badges">
                <span className="dt-badge">
                  <BiPrinter size={16} />
                  Prepare &amp; print yourself
                </span>
                <span className="dt-badge">
                  <BiShieldAlt2 size={16} />
                  Secure tickets
                </span>
                <span className="dt-badge">
                  <BiScan size={16} />
                  Compatible with the Karamale Scanning App
                </span>
              </div>
            </header>

            <section className="dt-summary">
              <div className="dt-stat">
                <span>Budget</span>
                <strong>
                  <Money value={budget} />
                </strong>
              </div>
              <div className="dt-stat">
                <span>Balance</span>
                <strong>
                  <Money value={balance} />
                </strong>
              </div>
              <div className="dt-stat">
                <span>Cost per download</span>
                <strong>
                  R1.00 <em className="dt-tag">Launch price</em>
                </strong>
              </div>
            </section>

            {lowBalance && (
              <div className="dt-warn" role="alert">
                <IoIosWarning size={20} />
                <span>
                  Your balance is too low to print {ticketPrint} tickets.{' '}
                  <button onClick={increase}>Increase budget</button> or reduce the number.
                </span>
              </div>
            )}

            <h2 className="dt-section">Select ticket types</h2>

            {ticketCategory.length === 0 && (
              <div className="dt-empty">No ticket types have been loaded for this event.</div>
            )}

            {ticketCategory.map((item) => {
              const on = item.checked == 1
              return (
                <article key={item.ticketid} className={`dt-ticket${on ? ' is-on' : ''}`}>
                  <button
                    type="button"
                    className="dt-ticket-head"
                    aria-pressed={on}
                    onClick={() => selected(item.ticketid, item.checked)}
                  >
                    {on ? (
                      <IoIosCheckmarkCircle size={28} className="dt-check on" />
                    ) : (
                      <IoIosRadioButtonOff size={28} className="dt-check" />
                    )}
                    <span className="dt-name">{categoryLabel(item.category)}</span>
                    <span className="dt-loaded">
                      <span>
                        <ImMan color="#e07b00" /> {item.initial_load} loaded
                      </span>
                      <span>
                        <FaChild color="#2b8fd6" /> {item.kids_initial_load} loaded
                      </span>
                    </span>
                  </button>

                  {on && (
                    <div className="dt-ticket-body">
                      {renderRow(item, 'adults')}
                      {renderRow(item, 'kids')}
                    </div>
                  )}
                </article>
              )
            })}
          </div>

          <div className={`dt-bar${collapsed ? ' is-collapsed' : ''}`}>
            <div className="dt-bar-inner">
              <div className="dt-totals">
                <div>
                  <span>Quantity</span>
                  <strong>{ticketPrint}</strong>
                </div>
                <div>
                  <span>Total cost</span>
                  <strong>R{costs}</strong>
                </div>
                <div>
                  <span>Est. revenue</span>
                  <strong>R{estimatedRevenue}</strong>
                </div>
              </div>
              <button className="dt-cta" disabled={!canPrepare || preparing} onClick={prepare}>
                {preparing ? (
                  <ClipLoader color="#fff" loading={true} size={18} />
                ) : (
                  'Prepare download'
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`dt-toast${errorDisplay ? ' show' : ''}`}
        role="status"
        onClick={() => setErrorDisplay(false)}
      >
        {error}
      </div>
    </div>
  )
}

export default Downloadtickets
